<button mat-icon-button (click)="onPrev()"><mat-icon>chevron_left</mat-icon></button>
<input matInput readonly [formControl]="dateControl" [matDatepicker]="datepicker" [min]="min" [max]="max" (click)="datepicker.open()" (ngModelChange)="dateChange.emit($event)">
<mat-datepicker #datepicker [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
<button mat-icon-button (click)="onNext()"><mat-icon>chevron_right</mat-icon></button>
